import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FaLightbulb, FaCogs, FaUsers, FaChartLine } from 'react-icons/fa';

const WhitePaper = () => {
    return (
        <Container className="py-5">
            <Row className="mb-5">
                <Col lg={8} className="mx-auto text-center">
                    <h1 className="display-4 mb-4">agenti.quest - Our Story</h1>
                    <p className="lead text-muted">
                        Bringing Joy and Productivity Through Curated AI Tools and Products
                    </p>
                    <div className="text-muted mb-4">
                        Version 1.0 - January 2025
                    </div>
                </Col>
            </Row>

            <Row className="mb-5">
                <Col lg={10} className="mx-auto">
                    <Card className="border-0 shadow-sm mb-4">
                        <Card.Body>
                            <h2 className="mb-4">Executive Summary</h2>
                            <p>
                                Fun AI Agent is on a mission to make workdays happier and more productive through carefully curated 
                                AI tools and products. Our platform delivers daily discoveries that bring joy to workflows, 
                                combining cutting-edge AI technology with a focus on user experience and delight.
                            </p>
                        </Card.Body>
                    </Card>

                    <Card className="border-0 shadow-sm mb-4">
                        <Card.Body>
                            <h3 className="mb-4">
                                <FaLightbulb className="me-2 text-primary" />
                                Vision & Mission
                            </h3>
                            <ul className="list-unstyled">
                                <li className="mb-3">• Make AI discovery fun and delightful</li>
                                <li className="mb-3">• Curate only the most useful and enjoyable AI tools</li>
                                <li className="mb-3">• Help people find joy in their daily work</li>
                                <li className="mb-3">• Democratize access to productivity-boosting AI</li>
                            </ul>
                        </Card.Body>
                    </Card>

                    <Card className="border-0 shadow-sm mb-4">
                        <Card.Body>
                            <h3 className="mb-4">
                                <FaCogs className="me-2 text-primary" />
                                Technology Stack
                            </h3>
                            <Row>
                                <Col md={6}>
                                    <h5>Platform Architecture</h5>
                                    <ul className="list-unstyled">
                                        <li className="mb-2">• Decentralized infrastructure</li>
                                        <li className="mb-2">• Smart contract integration</li>
                                        <li className="mb-2">• AI agent verification system</li>
                                        <li className="mb-2">• Cross-chain compatibility</li>
                                    </ul>
                                </Col>
                                <Col md={6}>
                                    <h5>Security Features</h5>
                                    <ul className="list-unstyled">
                                        <li className="mb-2">• Multi-signature governance</li>
                                        <li className="mb-2">• Automated security audits</li>
                                        <li className="mb-2">• Decentralized identity</li>
                                        <li className="mb-2">• Encrypted data storage</li>
                                    </ul>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>

                    <Card className="border-0 shadow-sm mb-4">
                        <Card.Body>
                            <h3 className="mb-4">
                                <FaUsers className="me-2 text-primary" />
                                Subscription Benefits
                            </h3>
                            <Row>
                                <Col md={6}>
                                    <h5>Community</h5>
                                    <p>Subscribers can participate in:</p>
                                    <ul className="list-unstyled">
                                        <li className="mb-2">• Platform development decisions</li>
                                        <li className="mb-2">• Feature prioritization</li>
                                        <li className="mb-2">• Beta testing opportunities</li>
                                    </ul>
                                </Col>
                                <Col md={6}>
                                    <h5>Benefits</h5>
                                    <ul className="list-unstyled">
                                        <li className="mb-2">• Priority support</li>
                                        <li className="mb-2">• Early access to new features</li>
                                        <li className="mb-2">• Advanced AI recommendations</li>
                                        <li className="mb-2">• Community recognition</li>
                                    </ul>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>

                    <Card className="border-0 shadow-sm mb-4">
                        <Card.Body>
                            <h3 className="mb-4">
                                <FaChartLine className="me-2 text-primary" />
                                Roadmap
                            </h3>
                            <div className="roadmap">
                                <div className="roadmap-item mb-4">
                                    <h5>Phase 1: Foundation (Q1 2025)</h5>
                                    <ul className="list-unstyled">
                                        <li className="mb-2">• Platform launch</li>
                                        <li className="mb-2">• Subscription launch event</li>
                                        <li className="mb-2">• Initial partnerships</li>
                                    </ul>
                                </div>
                                <div className="roadmap-item mb-4">
                                    <h5>Phase 2: Expansion (Q2-Q3 2025)</h5>
                                    <ul className="list-unstyled">
                                        <li className="mb-2">• DAO implementation</li>
                                        <li className="mb-2">• Advanced search features</li>
                                        <li className="mb-2">• Mobile app launch</li>
                                    </ul>
                                </div>
                                <div className="roadmap-item">
                                    <h5>Phase 3: Scaling (Q4 2025)</h5>
                                    <ul className="list-unstyled">
                                        <li className="mb-2">• Cross-chain integration</li>
                                        <li className="mb-2">• AI agent marketplace</li>
                                        <li className="mb-2">• Global expansion</li>
                                    </ul>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default WhitePaper; 